import { uuid } from '@elfsight/lib-utils';
import { commonDefaultSettings } from '../commonDefaultSettings';

/**
  @deprecated константа заменена на хук. Например: choiceSettings => useChoiceSettings
*/

export const dropdownSettings = {
  ...commonDefaultSettings,
  label: 'Dropdown',
  hint: '',
  placeholder: '',
  options: [
    {
      value: 0,
      name: 'Option 1',
      id: uuid()
    },
    {
      value: 1,
      name: 'Option 2',
      id: uuid()
    }
  ],
  initialValue: null,
  fieldID: 'dropdown'
};
